export default __webpack_public_path__ + "ef86b3eaa3cafcaa9d31ec8f08dd8253.jpeg";